import { Plus, Check, X, Pencil, Trash2 } from "lucide-react";

export default function WatchlistsSidebar({
  watchlists,
  selectedId,
  onSelect,
  loading,
  creating,
  setCreating,
  newName,
  setNewName,
  onCreate,
  renamingId,
  setRenamingId,
  renameValue,
  setRenameValue,
  onRename,
  onDelete,
}) {
  return (
    <div className="border-b lg:border-b-0 lg:border-r border-zinc-900">
      <div className="px-4 py-3 border-b border-zinc-900 flex items-center justify-between">
        <span className="text-label">Lists ({watchlists.length})</span>
        <button
          data-testid="new-watchlist-btn"
          onClick={() => setCreating((c) => !c)}
          className="text-zinc-400 hover:text-white p-1"
          title="New watchlist"
        >
          <Plus size={14} />
        </button>
      </div>

      {creating && (
        <div className="px-3 py-2 border-b border-zinc-900 flex items-center gap-2 bg-[#0d0d0f]">
          <input
            data-testid="new-watchlist-input"
            autoFocus
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && onCreate()}
            placeholder="e.g. Income ETFs"
            className="flex-1 bg-transparent border border-zinc-800 px-2 py-1.5 text-sm outline-none focus:border-zinc-500"
          />
          <button
            data-testid="new-watchlist-confirm"
            onClick={onCreate}
            className="text-[#00E676] p-1 hover:bg-zinc-900"
          >
            <Check size={14} />
          </button>
          <button
            onClick={() => {
              setCreating(false);
              setNewName("");
            }}
            className="text-zinc-500 hover:text-white p-1"
          >
            <X size={14} />
          </button>
        </div>
      )}

      {loading ? (
        <div className="p-4 text-xs text-zinc-500">Loading…</div>
      ) : watchlists.length === 0 ? (
        <div className="p-4 text-xs text-zinc-500">
          No watchlists yet. Click <span className="font-mono text-zinc-300">+</span> to create one.
        </div>
      ) : (
        <ul>
          {watchlists.map((w) => (
            <li
              key={w.watchlist_id}
              className={`border-b border-zinc-900 last:border-b-0 ${
                selectedId === w.watchlist_id ? "bg-zinc-900/40" : ""
              }`}
            >
              {renamingId === w.watchlist_id ? (
                <div className="flex items-center gap-1 px-3 py-2">
                  <input
                    autoFocus
                    value={renameValue}
                    onChange={(e) => setRenameValue(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && onRename(w.watchlist_id)}
                    className="flex-1 bg-transparent border border-zinc-800 px-2 py-1 text-sm outline-none focus:border-zinc-500"
                  />
                  <button onClick={() => onRename(w.watchlist_id)} className="text-[#00E676] p-1">
                    <Check size={12} />
                  </button>
                  <button onClick={() => setRenamingId(null)} className="text-zinc-500 p-1">
                    <X size={12} />
                  </button>
                </div>
              ) : (
                <div
                  className="flex items-center justify-between px-3 py-2 group cursor-pointer"
                  onClick={() => onSelect(w.watchlist_id)}
                  data-testid={`watchlist-item-${w.watchlist_id}`}
                >
                  <div className="min-w-0 flex-1">
                    <div className="text-sm truncate font-medium">{w.name}</div>
                    <div className="text-[10px] font-mono text-zinc-500 uppercase tracking-widest">
                      {w.tickers.length} ticker{w.tickers.length === 1 ? "" : "s"}
                    </div>
                  </div>
                  <div className="flex items-center gap-0.5 opacity-0 group-hover:opacity-100 transition-opacity">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setRenamingId(w.watchlist_id);
                        setRenameValue(w.name);
                      }}
                      className="text-zinc-500 hover:text-white p-1"
                      title="Rename"
                    >
                      <Pencil size={11} />
                    </button>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onDelete(w.watchlist_id);
                      }}
                      className="text-zinc-500 hover:text-[#FF3B30] p-1"
                      title="Delete"
                    >
                      <Trash2 size={11} />
                    </button>
                  </div>
                </div>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
